var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Box from '@mui/material/Box';
import MuiFab from '@mui/material/Fab';
import React from 'react';
import { container, titleStyle, onlyIcon, iconStyle } from './Fab.style';
export const Fab = (_a) => {
    var { icon, title, size, disabled, positionV = 'bottom', positionH = 'right', action } = _a, rest = __rest(_a, ["icon", "title", "size", "disabled", "positionV", "positionH", "action"]);
    const actionDisableFocus = (e) => {
        action();
        e.preventDefault();
        setTimeout(e.target.blur(), 500);
    };
    return !!icon && !!title ? (React.createElement(MuiFab, Object.assign({ onClick: actionDisableFocus, variant: 'extended', sx: container(size, positionV, positionH), disabled: disabled, size: size }, rest),
        React.createElement(Box, { sx: iconStyle(size) }, icon),
        React.createElement(Box, { sx: titleStyle(size) },
            React.createElement(Box, null, title)))) : icon ? (React.createElement(MuiFab, { onClick: action, variant: 'circular', sx: onlyIcon(size, positionV, positionH), disabled: disabled, size: size },
        React.createElement(Box, { sx: iconStyle(size) }, icon))) : (React.createElement(MuiFab, { onClick: action, variant: 'extended', sx: container(size, positionV, positionH), disabled: disabled, size: size },
        React.createElement(Box, { sx: titleStyle(size) }, title)));
};
